import { UseInfiniteQueryResult } from "@tanstack/react-query";
import { useEffect } from "react";

export default function useAutoRetrievePagedQuery<TData, TError>(
  query: UseInfiniteQueryResult<TData, TError>,
): UseInfiniteQueryResult<TData, TError> {
  // TODO - Allow for custom logic on when to stop fetching
  useEffect(() => {
    if (query.hasNextPage && !query.isFetching) {
      console.log("Actually fetching");
      query.fetchNextPage();
    }
  }, [query]);

  return query;
}
